import React from "react";

import { combineClassNames } from "@utils/appUtils";

import { WPTypogrpahy } from "@components/WPTypography";
import { typographyVariants } from "@components/WPTypography";

import { colors } from "@common/styles/Theme";

import "./index.css";

const SpinnerSVG = ({ size = "40px" }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='loader-spinner'
    aria-label='Loading'
  >
    <g clipPath='url(#wp-loader-clip)'>
      <g transform='matrix(0.03 0 0 0.03 40 40)'>
        <foreignObject x='-1083.33' y='-1083.33' width='2166.67' height='2166.67'>
          <div
            style={{
              background:
                "conic-gradient(from 90deg, rgba(0, 0, 0, 0.8) 0deg, rgba(18, 131, 112, 0) 0.036deg, rgba(0, 118, 114, 1) 360deg)",
              height: "100%",
              width: "100%",
              opacity: 1,
            }}
          />
        </foreignObject>
      </g>
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M66.9541 34.0013C68.3234 33.8246 69.5767 34.7915 69.7534 36.1609C69.9176 37.4338 70 38.716 70 39.9996C70 41.3803 68.8807 42.4996 67.5 42.4996C66.1193 42.4996 65 41.3803 65 39.9996C65 38.93 64.9314 37.8614 64.7945 36.8006C64.6178 35.4313 65.5847 34.178 66.9541 34.0013Z'
      fill='#007672'
    />
    <defs>
      <clipPath id='wp-loader-clip'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70ZM40 65C53.8071 65 65 53.8071 65 40C65 26.1929 53.8071 15 40 15C26.1929 15 15 26.1929 15 40C15 53.8071 26.1929 65 40 65Z'
        />
      </clipPath>
    </defs>
  </svg>
);

const CircularLoader = ({ size = "40px", className, label }) => (
  <div className={combineClassNames("loader", label && "loader-with-label", className)} data-test-id='wp-loader'>
    <SpinnerSVG size={size} />
    {label && (
      <WPTypogrpahy variant={typographyVariants.body} style={{ color: colors.PrimaryDarkAquaMarine }}>
        {label}
      </WPTypogrpahy>
    )}
  </div>
);

export default CircularLoader;
